import React from "react";
import Downshift from "downshift";
import cx from "classnames";
import PropTypes from "prop-types";
import {escapeRegexCharacters} from "../utils";


class SimpleAutocomplete extends React.PureComponent {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.string), // that means SIMPLE
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {items: [], value: ''};

    onChange = (value, stateAndHelpers) => {
        if (stateAndHelpers.isOpen || value)
            this.props.onChange({target: {name: this.props.name, value}});
    };

    render() {
        const {name, value, placeholder} = this.props;
        const id = this.props.id || name;

        const re = new RegExp(escapeRegexCharacters(value.trim()), 'i');
        const items = this.props.items.filter(item => re.test(item)).slice(0, 10);

        return (
            <Downshift selectedItem={null} onInputValueChange={this.onChange}>
                {({getMenuProps, getInputProps, getItemProps, isOpen, highlightedIndex, openMenu}) =>
                    <div className="custom-select">
                        <input {...getInputProps({
                            type: "text",
                            id,
                            className: 'form-input',
                            name,
                            value,
                            placeholder,
                            onFocus: openMenu
                        })}/>
                        {isOpen && items.length > 0
                            ? <ul {...getMenuProps({className: "menu"})}>
                                {items.map((item, index) =>
                                    <li {...getItemProps({key: item, item, index, className: "menu-item"})}>
                                        <a className={cx({'active': highlightedIndex === index})}>{item}</a>
                                    </li>
                                )}
                            </ul>
                            : null}
                    </div>
                }
            </Downshift>
        );
    }
}

export default SimpleAutocomplete;